import React from "react";

const Superscript = ({ value }) => (
  <span className="align-text-top text-xl">{value}</span>
);

const Subscript = ({ value }) => <span className="text-xl">{value}</span>;

const OfferValue = ({ value }) => {
  const valueFormatted = [];

  for (let i = 0; i < value.length; i++) {
    const { style, text } = value[i];
    if (style === "normal") {
      valueFormatted.push(<span key={i}>{text}</span>);
    }
    if (style === "superscript") {
      valueFormatted.push(<Superscript key={i} value={text} />);
    }
    if (style === "subscript") {
      valueFormatted.push(<Subscript key={i} value={text} />);
    }
  }

  return (
    <p
      className="text-4xl font-semibold text-green-primary"
      style={{ lineHeight: "normal" }}
    >
      {valueFormatted}
    </p>
  );
};

const OfferLogo = ({ imageUrl, name }) => {
  if (imageUrl) {
    return (
      <img
        className="w-full h-8 object-contain mb-1"
        src={imageUrl}
        alt={name}
      />
    );
  }

  return (
    <div className="flex items-center h-8">
      <p className="w-full font-semibold">{name}</p>
    </div>
  );
};

const Offer = ({ className = "", offer }) => {
  if (!offer) {
    return (
      <div className={`${className}`}>
        <div
          className="rounded-sm common-container py-2 px-4 md:py-4 flex justify-center items-center h-full"
          style={{ minHeight: "100px" }}
        >
          <p className="text-center italic">More coming soon.</p>
        </div>
      </div>
    );
  }

  const { name, type, value, imageUrl, subtext, externalUrl } = offer;

  return (
    <div className={`${className}`}>
      <a href={externalUrl} target="_blank">
        <div className="rounded-sm common-container py-2 px-4 md:py-4 text-center flex-col relative min-h-full hover:shadow-lg">
          <OfferLogo imageUrl={imageUrl} name={name} />
          <OfferValue type={type} value={value} />
          <p className="text-xs md:text-base">{subtext}</p>
          <span className="absolute bottom-0 right-0 p-3 leading-none block">
            <i
              className="fa-solid fa-circle-plus text-gray-secondary hover:text-gray-primary"
              alt="Learn More"
            />
          </span>
        </div>
      </a>
    </div>
  );
};

export default Offer;
